export default {
  'business-growth': 'Laat uw bedrijf groeien',
}
